import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_KMC_Dispensaries = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">{t("KMC Dispensariess")}</h3>
                  </div>
                  <div className="health-dept-table table2">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td
                            width="10%"
                            className="text-white tble-brder-left"
                          >
                            {t("Sl.No")}
                          </td>
                          <td width="27%" className="text-white">
                            {t("Name")}
                          </td>
                          <td width="43%" className="text-white">
                            {t("Address")}
                          </td>
                          <td width="12%" className="text-white">
                            {t("Ward")}
                          </td>
                          <td
                            width="10%"
                            className="text-white tble-brder-right"
                          >
                            {t("Borough")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="5%" align="center">
                            1
                          </td>
                          <td width="27%">{t("Chitpur Dispensary")}</td>
                          <td width="43%">
                            {t("3, Gopal Mukherjee Road, Kol-2")}
                          </td>
                          <td width="12%" align="center">
                            6
                          </td>
                          <td width="13%" align="center">
                            I
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="5%" align="center">
                            2
                          </td>
                          <td width="27%">
                            {t("Tallah Pumping Station Dispensary")}
                          </td>
                          <td width="43%">{t("71, B.T. Road")}</td>
                          <td width="12%" align="center">
                            5
                          </td>
                          <td width="13%" align="center">
                            I
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="5%" align="center">
                            3
                          </td>
                          <td width="27%">{t("Hatibagan Dispensary")}</td>
                          <td width="43%">{t("72/1, Grey St., Kol-6")}</td>
                          <td width="12%" align="center">
                            11
                          </td>
                          <td width="13%" align="center">
                            II
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">4</td>
                          <td>{t("Narkeldanga Dispensary")}</td>
                          <td>{t("109 Narkeldanga Dispensary")}</td>
                          <td align="center">30</td>
                          <td align="center">III</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">5</td>
                          <td>{t("Ultadanga Dispensary")}</td>
                          <td>{t("123, Ultadanga Main Road, Kol-14")}</td>
                          <td align="center">14</td>
                          <td align="center">III</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">6</td>
                          <td>{t("Rajabazar Dispensary")} </td>
                          <td>{t("40, Canal West Road")} </td>
                          <td align="center">29</td>
                          <td align="center">III</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">7</td>
                          <td>{t("Baithakkhana Dispensary")}</td>
                          <td>{t("92 Baithakkhana Road, Kol")}</td>
                          <td align="center">37</td>
                          <td align="center">V</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">8</td>
                          <td>{t("Nafar Koley Dispensary")}</td>
                          <td>7, Nafar Koley Road, Kol</td>
                          <td align="center">36</td>
                          <td align="center">V</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">9</td>
                          <td>{t("Hazi Md Mohasin Sq Dispensary")}</td>
                          <td>{t("21, Road, Hazi Md Mohasin Sq, Kol")}</td>
                          <td align="center">61</td>
                          <td align="center">VI</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">10</td>
                          <td>{t("E.W.S. Dispensary")}</td>
                          <td>{t("149, A.J.C. Bose Road, Kol")}</td>
                          <td align="center">55</td>
                          <td align="center">VI</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">11</td>
                          <td>{t("Taltala Dispensary")}</td>
                          <td>{t("3, Girish Bose Road")}</td>
                          <td align="center">&nbsp;</td>
                          <td align="center">VI</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">12</td>
                          <td>{t("Central Dispensary")}</td>
                          <td>
                            {t("KMC Main Dispensary, 5, S.N. Banerjee Road")}
                          </td>
                          <td align="center">46</td>
                          <td align="center">VI</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">13</td>
                          <td>{t("Dhapa Kachari Bari Dispensary")}</td>
                          <td>{t("Dhapa Road, Kol")}</td>
                          <td align="center">58</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">14</td>
                          <td>{t("Gobra Dispensary")}</td>
                          <td>{t("59 Christopher Road, Kol")}</td>
                          <td align="center">58</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">15</td>
                          <td>{t("Tangra Dispensary")}</td>
                          <td>{t("48K, D.C. Dey Road, Kol")}</td>
                          <td align="center">57</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">16</td>
                          <td>{t("New Tangra Dispensary")}</td>
                          <td>{t("12, Gobinda Khatick Road, Kol")}</td>
                          <td align="center">58</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">17</td>
                          <td>{t("Silver Jubilee Dispensary")}</td>
                          <td>{t("117, B.B.Chatterjee Road, Kol-42")}</td>
                          <td align="center">67</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">18</td>
                          <td>{t("Bhowanipore Dispensary")}</td>
                          <td>{t("26,D.G.Road, Kol-29")}</td>
                          <td align="center">71</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">19</td>
                          <td>{t("Tiljala Dispensary")}</td>
                          <td>{t("9B, Tiljala Shibtala Lane, Kol")}</td>
                          <td align="center">65</td>
                          <td align="center">VII</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">20</td>
                          <td>{t("Kalighat Dispensary")}</td>
                          <td>{t("240, Kalighat Road, Kol-26")}</td>
                          <td align="center">83</td>
                          <td align="center">IX</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">21</td>
                          <td>{t("Chetla Dispensary")}</td>
                          <td>{t("29/1, Chetla Central Road, Kol")}</td>
                          <td align="center">82</td>
                          <td align="center">IX</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">22</td>
                          <td>{t("Khidirpore Dispensary")}</td>
                          <td>{t("15, Dent Mission Road, Kol-23")}</td>
                          <td align="center">77</td>
                          <td align="center">IX</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">23</td>
                          <td>{t("Garden Reach Dispensary")}</td>
                          <td>{t("P-3, Prince Dilcour Jan Lane")}</td>
                          <td align="center">134</td>
                          <td align="center">XV</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_KMC_Dispensaries;
